import React from "react";

const NotFound = () => (
  <div style={{ textAlign: "center", padding: "60px 20px" }}>
    <h1 style={{ fontSize: "48px", marginBottom: "16px", color: "#666" }}>
      404
    </h1>
    <p style={{ fontSize: "18px", marginBottom: "24px", color: "#767676" }}>
      Stránka nebyla nalezena
    </p>
    <a
      href="/"
      style={{ color: "#1976d2", textDecoration: "none", fontSize: "16px" }}
    >
      Přejít na hlavní stránku
    </a>
  </div>
);

export default NotFound;
